import pictureMobile from './teaser-card_mobile.jpg';
import pictureTablet from './teaser-card_tablet.jpg';
import pictureDesktop from './teaser-card_desktop.jpg';
import style from './teaser-card.scss';
import Dotdotdot from 'dotdotdot-js';

const script = () => {
  const cssClass: string = 'TeaserCard';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      continue; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    const wrappers = elt.querySelectorAll( `.${cssClass}-title, .${cssClass}-desc`);

    for (const item of wrappers) {
      if (item !== null) {
        const options = {
          // Options go here
        };
        const dotdotdot = new Dotdotdot(item, options);
      }
    };
  }
};

export {
  style,
  pictureMobile,
  pictureTablet,
  pictureDesktop,
  script,
};
